import { ProjectMembersPage } from "@/features/projects/project-members.page";
import { CreateContainerShell } from "@/features/workspaces";
import { createFileRoute } from "@tanstack/react-router";

function ProjectMembersRoute() {
  return (
    <CreateContainerShell
      title="Add project members"
      subtitle="Add members to collaborate on your project. You can also add email addresses of people who aren’t Kairo users yet."
      withIllustration={false}
      step={2}
      totalSteps={3}
    >
      <ProjectMembersPage continueButton={true} leaveProjectButton={false} joinRequests={false} />
    </CreateContainerShell>
  );
}

export const Route = createFileRoute(
  "/_authenticated/workspaces/$slug/projects/$projectSlug/create/invite",
)({
  component: ProjectMembersRoute,
});
